module.exports = __webpack_public_path__ + "static/media/categorycard3.90a19e27.svg";